"use client";

import "@/css/goldfinch/index.css";
import { usePathname } from "next/navigation";

import { MygaLoadingScreen } from "@/apps/charm/lib/myga/loading";
import { LoadingPage } from "@/apps/charm/lib/pages/core/LoadingPage";
import { isMygaPrivatePath } from "@/lib/myga-application/privacy";

export function RouteLoadingPage() {
  const pathname = usePathname();
  return isMygaPrivatePath(pathname) ? <MygaLoadingScreen /> : <LoadingPage />;
}
